
/**
 * The base width styles for the theme.
 * You can add new width values using this file.
 * You can customize the width for the entire theme using this file.
 */

// Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

// types
export interface Types {
  // Dynamic width: number * 2 = pixels (e.g., width2 = 4px, width3 = 6px)
  width2: string;   // 4px (2 * 2)
  width3: string;   // 6px (3 * 2)
  width4: string;   // 8px (4 * 2)
  width5: string;   // 10px (5 * 2)
  width6: string;   // 12px (6 * 2)
  width7: string;   // 14px (7 * 2)
  width8: string;   // 16px (8 * 2)
  width9: string;   // 18px (9 * 2)
  width10: string;  // 20px (10 * 2)
  width11: string;  // 22px (11 * 2)
  width12: string;  // 24px (12 * 2)
  width12_5: string; // 25px (12.5 * 2)
  width14: string;  // 28px (14 * 2)
  width15: string;  // 30px (15 * 2)
  width16: string;  // 32px (16 * 2)
  width20: string;  // 40px (20 * 2)
  width21: string;  // 42px (21 * 2)
  width22: string;  // 44px (22 * 2)
  width25: string;  // 50px (25 * 2)
  width28: string;  // 56px (28 * 2)
  width31_5: string; // 63px (31.5 * 2)
  width32_5: string; // 65px (32.5 * 2)
  width35: string;  // 70px (35 * 2)
  width50: string;  // 100px (50 * 2)
  width59: string;  // 118px (59 * 2)
  width62_5: string; // 125px (62.5 * 2)
  width75: string;  // 150px (75 * 2)
  width85_5: string; // 171px (85.5 * 2)
  width107_5: string; // 215px (107.5 * 2)
  width172_5: string; // 345px (172.5 * 2)
  width225: string;  // 450px (225 * 2)
  width23_5: string; // 47px (23.5 * 2)
  width32: string;   // 64px (32 * 2)
  // Percentage and viewport widths
  full: string;      // 100%
  fullVw: string;    // 100vw
  ninetyPercent: string;  // 90%
  ninetyVw: string;  // 90vw
}

const width = {
  // Dynamic width: number * 2 = pixels
  width2: pxToRem(4),      // 2 * 2 = 4px
  width3: pxToRem(6),      // 3 * 2 = 6px
  width4: pxToRem(8),      // 4 * 2 = 8px
  width5: pxToRem(10),     // 5 * 2 = 10px
  width6: pxToRem(12),     // 6 * 2 = 12px
  width7: pxToRem(14),     // 7 * 2 = 14px
  width8: pxToRem(16),     // 8 * 2 = 16px
  width9: pxToRem(18),     // 9 * 2 = 18px
  width10: pxToRem(20),    // 10 * 2 = 20px
  width11: pxToRem(22),    // 11 * 2 = 22px
  width12: pxToRem(24),    // 12 * 2 = 24px
  width12_5: pxToRem(25),  // 12.5 * 2 = 25px
  width14: pxToRem(28),    // 14 * 2 = 28px
  width15: pxToRem(30),    // 15 * 2 = 30px
  width16: pxToRem(32),    // 16 * 2 = 32px
  width20: pxToRem(40),    // 20 * 2 = 40px
  width21: pxToRem(42),    // 21 * 2 = 42px
  width22: pxToRem(44),    // 22 * 2 = 44px
  width25: pxToRem(50),    // 25 * 2 = 50px
  width28: pxToRem(56),    // 28 * 2 = 56px
  width31_5: pxToRem(63),  // 31.5 * 2 = 63px
  width32_5: pxToRem(65),  // 32.5 * 2 = 65px
  width35: pxToRem(70),    // 35 * 2 = 70px
  width50: pxToRem(100),   // 50 * 2 = 100px
  width59: pxToRem(118),   // 59 * 2 = 118px
  width62_5: pxToRem(125), // 62.5 * 2 = 125px
  width75: pxToRem(150),   // 75 * 2 = 150px
  width85_5: pxToRem(171), // 85.5 * 2 = 171px
  width107_5: pxToRem(215), // 107.5 * 2 = 215px
  width172_5: pxToRem(345), // 172.5 * 2 = 345px
  width225: pxToRem(450),   // 225 * 2 = 450px
  width23_5: pxToRem(47),   // 23.5 * 2 = 47px
  width32: pxToRem(64),     // 32 * 2 = 64px
  // Percentage and viewport widths
  full: "100%",             // 100%
  fullVw: "100vw",          // 100vw
  ninetyPercent: "90%",     // 90%
  ninetyVw: "90vw",         // 90vw
} as Types;

export default width;

